import CollapseIcon from "@mui/icons-material/CloseFullscreenRounded";
import ExpandIcon from "@mui/icons-material/OpenInFullRounded";
import { Box, Divider, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import type { ReactNode } from "react";
import CloseIconButton from "@entrilia/shared/components/CloseIconButton";

interface Props {
  title: string;
  status?: ReactNode;
  actions?: ReactNode;
  isExpanded: boolean;
  onToggleExpand: () => void;
  onClose: () => void;
  children: ReactNode;
}

const ContentPanelLayout = ({ title, status, actions, isExpanded, onToggleExpand, onClose, children }: Props) => {
  return (
    <Stack sx={{ flex: 1, minWidth: 0, height: "100%", bgcolor: "background.paper" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2, px: 2, py: 1 }}>
        <Stack direction="row" spacing={1} sx={{ alignItems: "center", minWidth: 0 }}>
          <Typography variant="subtitle1" noWrap>
            {title}
          </Typography>
          {status}
        </Stack>
        <Stack direction="row" spacing={1} sx={{ alignItems: "center", flexShrink: 0 }}>
          {actions}
          <Tooltip title={isExpanded ? "Show chat" : "Full width"}>
            <IconButton onClick={onToggleExpand}>{isExpanded ? <CollapseIcon /> : <ExpandIcon />}</IconButton>
          </Tooltip>
          <CloseIconButton onClick={onClose} />
        </Stack>
      </Box>
      <Divider />
      <Stack sx={{ flex: 1, minHeight: 0 }}>{children}</Stack>
    </Stack>
  );
};

export default ContentPanelLayout;
